
export default {
  name: 'PDPMainContainer',
};
